import { stableKey } from '../../../lib';

export const sitePreviewKeys = {
  all: stableKey(['sitePreview']),
  getSiteUrls: (metaSiteId: string) => stableKey(['sitePreview', 'getSiteUrls', metaSiteId]),
};
